export default __webpack_public_path__ + "static/media/card4.da24d7bd.jpeg";